module.exports = __webpack_public_path__ + "static/media/new-gandirect-logo.7a7c424c.svg";